"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleSkeleton = exports.SubtitleSkeleton = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(2),
  margin: theme.spacing(0, 2),
  [theme.breakpoints.up('md')]: {
    gap: theme.spacing(3),
    margin: theme.spacing(0)
  }
}));
const SubtitleSkeleton = exports.SubtitleSkeleton = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  margin: theme.spacing(0, 'auto', 6),
  width: '100%',
  height: 30,
  [theme.breakpoints.up('sm')]: {
    width: 550
  },
  [theme.breakpoints.up('lg')]: {
    margin: theme.spacing(0, 'auto', 8)
  }
}));
const TitleSkeleton = exports.TitleSkeleton = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  width: 206,
  height: 35,
  [theme.breakpoints.up('sm')]: {
    width: 275,
    height: 47
  }
}));
